import React, { Component } from 'react';
import DialogModal from '../DialogModal/DialogModal';
import Share from '../../Share/Share';

class ShareModal extends Component {
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      // initial focus set on toggle open of Share modal
      setTimeout(() => this.shareModal && this.shareModal.focus(), 250); // allow for modal transition in before setting focus
    }
  }

  render() {
    const {
      shareUrl,
      stopNumber,
      closeModal,
      published,
      uptoDate,
      tourId,
      isOpen,
      tourName,
      history,
      aid,
      sendHubspotEvent,
    } = this.props;

    return (
      <DialogModal
        closeModal={closeModal}
        className="share"
        isOpen={isOpen}
        shouldCloseOnOverlayClick
      >
        <div
          className="modal"
          tabIndex={0}
          aria-label="share tour modal"
          ref={el => (this.shareModal = el)}
        >
          <Share
            tourId={tourId}
            stopNumber={stopNumber}
            tourName={tourName}
            shareUrl={shareUrl}
            published={published}
            uptoDate={uptoDate}
            embed
            showPublishButton
            closeModal={closeModal}
            history={history}
            aid={aid}
            sendHubspotEvent={sendHubspotEvent}
          />
        </div>
      </DialogModal>
    );
  }
}

export default ShareModal;
